import React from "react";

export function runtimeEnvironment(env = process.env) {
  const configured = String(env.REACT_APP_ENV || "").trim().toLowerCase();
  if (configured) return configured;
  return env.NODE_ENV === "production" ? "unconfigured" : "development";
}

export default function EnvironmentBanner() {
  const environment = runtimeEnvironment();
  if (environment === "production") return null;
  const label = environment === "unconfigured" ? "ENVIRONMENT NOT CONFIGURED" : `${environment.toUpperCase()} ENVIRONMENT`;
  return (
    <div className={`px-3 py-1.5 text-center text-[11px] font-bold uppercase tracking-[0.16em] ${environment === "unconfigured" ? "bg-rose-700 text-white" : "bg-amber-300 text-amber-950"}`} data-testid="environment-banner">
      {label} · Do not enter production data
    </div>
  );
}
